import { Box, Grid, Typography } from "@mui/material";
import howItWorksStyles from "./howItWorks.styles";
import { HOW_IT_WORKS_SECTION_STEPS } from "../../../constants/lang";

const HowItWorksSection = () => {
    const styles = howItWorksStyles;
    const steps = HOW_IT_WORKS_SECTION_STEPS;
    return (
        <Box sx={styles.container} id='how-it-works'>
            <Box sx={styles.headerContainer}>
                <Typography sx={styles.headerText}>How it Works</Typography>
                <Box sx={styles.headerLine} />
            </Box>
            <Grid container spacing={{ xs: 4, sm: 3, md: 1 }}>
                {steps.map((step, index) => (
                    <Grid item xs={6} md={3} key={index} sx={{ textAlign: { xs: "left", md: "center" }}}>
                        <Box sx={styles.stepContainer}>
                            <Box sx={styles.stepNumber}>{step.number}</Box>
                            <Box sx={styles.stepContent}>
                                <Typography sx={styles.stepTitle}>{step.title}</Typography>
                                <Typography sx={styles.stepDescription}>{step.description}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default HowItWorksSection;